var path = './login/oauth2.html';
var html = "<div class=\"container-fluid\">\n  <div class=\"row\">\n    <div class=\"offset3 span6\"></div>\n  </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;